import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=59c28d6c"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports